import { createAction } from '@reduxjs/toolkit';

// eslint-disable-next-line import/prefer-default-export
export const setLhsExpanded = createAction<{
  isLhsExpandedMobile: boolean;
  isLhsExpandedDesktop: boolean;
}>('SET_LHS_EXPANDED');
